
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`How do I fix flickering text after server side rendering?`}</h2>
    <p>{`When using global styling APIs like `}<a parentName="p" {...{
        "href": "/docs/api#createglobalstyle"
      }}><inlineCode parentName="a">{`createGlobalStyle`}</inlineCode></a>{` or the former `}<a parentName="p" {...{
        "href": "/docs/api#injectglobal"
      }}><inlineCode parentName="a">{`injectGlobal`}</inlineCode></a>{`, adding and removing certain styles from the DOM like `}<inlineCode parentName="p">{`@font-face`}</inlineCode>{` definitions can cause momentary flickering of text on the page. This typically happens during the rehydration phase of server-side rendering. We're still tweaking how these behaviors work to avoid the issue long-term.`}</p>
    <p>{`However, there is a CSS solution to the problem in the `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display"
      }}><inlineCode parentName="a">{`font-display`}</inlineCode>{` CSS rule`}</a>{`. By setting the rule to "fallback" mode, once a font has been loaded it will not be reloaded. This eliminates the flicker.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`@font-face {
  font-family: 'Foo';
  src: url('/path/to/foo.woff') format('woff');
  font-style: normal;
  font-weight: 400;
  font-display: fallback; /* <- this can be added to each @font-face definition */
}
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;